// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `html,
body {
  margin: 0;
  padding: 0;
  height: 100%;
}

body {
  font-family: inherit;
  font-style: inherit;
  font-weight: inherit;
  font-size: inherit;
  line-height: inherit;
  letter-spacing: inherit;
  min-height: inherit;
  color: inherit;
}

* {
  box-sizing: border-box;
}

/* width */
::-webkit-scrollbar {
  width: 10px;
}

/* Track */
::-webkit-scrollbar-track {
  background: transparent;
}

app {
  height: 100%;
}

.arrow-down {
  width: 0;
  height: 0;
  border-left: 5px solid transparent;
  border-right: 5px solid transparent;
  border-top: 5px solid #fff;
  display: inline-block;
  margin-right: 5px;
}

.arrow-right {
  margin-right: 5px;
  display: inline-block;
  width: 0;
  height: 0;
  border-top: 5px solid transparent;
  border-bottom: 5px solid transparent;
  border-left: 5px solid #fff;
}

input[type='text'],
input[type='number'] {
  font-size: 16px;
  padding: 5px 5px 5px 5px;
  display: block;
  background: transparent;
  color: #fff;
  width: 100%;
  border: none;
  border-bottom: 1px solid #5264ae;
}

input:focus {
  outline: none;
}

select {
  width: 100%;
  height: 30px;
  margin: 5px 0;
}

main {
  justify-content: center;
  height: 100%;


}
`, "",{"version":3,"sources":["webpack://./src/app/chart/chart.component.css"],"names":[],"mappings":"AAAA;;EAEE,SAAS;EACT,UAAU;EACV,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,oBAAoB;EACpB,kBAAkB;EAClB,oBAAoB;EACpB,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,sBAAsB;AACxB;;AAEA,UAAU;AACV;EACE,WAAW;AACb;;AAEA,UAAU;AACV;EACE,uBAAuB;AACzB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,QAAQ;EACR,SAAS;EACT,kCAAkC;EAClC,mCAAmC;EACnC,0BAA0B;EAC1B,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,qBAAqB;EACrB,QAAQ;EACR,SAAS;EACT,iCAAiC;EACjC,oCAAoC;EACpC,2BAA2B;AAC7B;;AAEA;;EAEE,eAAe;EACf,wBAAwB;EACxB,cAAc;EACd,uBAAuB;EACvB,WAAW;EACX,WAAW;EACX,YAAY;EACZ,gCAAgC;AAClC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,uBAAuB;EACvB,YAAY;;;AAGd","sourcesContent":["html,\nbody {\n  margin: 0;\n  padding: 0;\n  height: 100%;\n}\n\nbody {\n  font-family: inherit;\n  font-style: inherit;\n  font-weight: inherit;\n  font-size: inherit;\n  line-height: inherit;\n  letter-spacing: inherit;\n  min-height: inherit;\n  color: inherit;\n}\n\n* {\n  box-sizing: border-box;\n}\n\n/* width */\n::-webkit-scrollbar {\n  width: 10px;\n}\n\n/* Track */\n::-webkit-scrollbar-track {\n  background: transparent;\n}\n\napp {\n  height: 100%;\n}\n\n.arrow-down {\n  width: 0;\n  height: 0;\n  border-left: 5px solid transparent;\n  border-right: 5px solid transparent;\n  border-top: 5px solid #fff;\n  display: inline-block;\n  margin-right: 5px;\n}\n\n.arrow-right {\n  margin-right: 5px;\n  display: inline-block;\n  width: 0;\n  height: 0;\n  border-top: 5px solid transparent;\n  border-bottom: 5px solid transparent;\n  border-left: 5px solid #fff;\n}\n\ninput[type='text'],\ninput[type='number'] {\n  font-size: 16px;\n  padding: 5px 5px 5px 5px;\n  display: block;\n  background: transparent;\n  color: #fff;\n  width: 100%;\n  border: none;\n  border-bottom: 1px solid #5264ae;\n}\n\ninput:focus {\n  outline: none;\n}\n\nselect {\n  width: 100%;\n  height: 30px;\n  margin: 5px 0;\n}\n\nmain {\n  justify-content: center;\n  height: 100%;\n\n\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
